<template>
    <div>
        <div class="filter-heading cf">
            <p class="filter-title">
                Category <small v-if="selected.length">({{ selected.length }} applied)</small>
            </p>
        </div>
        <div class="filter-body">
            <div class="checkbox" v-for="category in filters" :key="category.id">
                <label>
                    <input type="checkbox" v-model="selected" :value="category.id" @change="bump">
                    <span class="faux-label">
                        {{ category.name }}
                    </span>
                </label>
            </div>
        </div>
        <div class="filter-footer" v-if="hiddenCount > filters.length">
            <button @click="expanded = false" v-if="expanded">Show less</button>
            <button @click="expanded = true" v-else-if="hiddenCount">Show {{ hiddenCount }} more </button>
        </div>
    </div>
</template>

<script>
    import { CategoryFilter } from '../../../Services/Search/CategoryFilter.js';

    export default {
        props: {
            current: {
                type: String,
                default: null,
            },
            expand: {
                type: Boolean,
                default: false,
            },
            handle: {
                type: String,
            },
            items: {
                type: [Object,Array],
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                selected: [],
                expanded: false,
            }
        },
        mounted() {
            if (this.current) {
                this.selected = this.current.split(':');
            }
        },
        computed: {
            hiddenCount() {
                return this.items ? this.items.length : 0;
            },
            filters() {
                if (this.expanded) {
                    return this.items;
                }

                let items = _.sortBy(this.items, 'name')

                return _.take(
                    items
                , 5);
            },
        },
        methods: {
            bump() {
                this.$emit('bump', new CategoryFilter('category', this.selected));
            },
            loaded() {
                this.$emit('loaded', new CategoryFilter('category', this.selected));
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/Filters/CategoryFilter.vue